import "./cadastro-participantes-vila-pinto.b081ef1c.js";
import "./firebase-init-coadesc.a6d910f2.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree555"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree555"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dCqD9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");

var $hPtJY = parcelRequire("hPtJY");
window.Buffer = (0, $6ZWSX.Buffer);
window.process = (0, (/*@__PURE__*/$parcel$interopDefault($hPtJY)));

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRequire("dCqD9");

var $dbOS5 = parcelRequire("dbOS5");

var $ilpIi = parcelRequire("ilpIi");
/* =========================
   CONFIG DINÂMICA
========================= */ const $78b1059b43b96c0c$var$BODY = document.body;
const $78b1059b43b96c0c$var$CONFIG = {
    territoryId: String($78b1059b43b96c0c$var$BODY.dataset.territoryId || "").trim(),
    territoryLabel: String($78b1059b43b96c0c$var$BODY.dataset.territoryLabel || "").trim(),
    territorySlug: String($78b1059b43b96c0c$var$BODY.dataset.territorySlug || "").trim(),
    redirectAfterSuccess: String($78b1059b43b96c0c$var$BODY.dataset.redirectUrl || "index.html").trim(),
    viacepBase: "https://viacep.com.br/ws",
    nominatimBase: "https://nominatim.openstreetmap.org/search"
};
const $78b1059b43b96c0c$var$CODE_CONFIG = {
    "vila-pinto": {
        casa: {
            prefix: "VPD",
            start: 300
        },
        condominio: {
            prefix: "VPCD",
            start: 10
        },
        comercio: {
            prefix: "VPCM",
            start: 10
        },
        outro: {
            prefix: "VPO",
            start: 300
        }
    },
    "cooadesc": {
        casa: {
            prefix: "COD",
            start: 1
        },
        condominio: {
            prefix: "COCD",
            start: 1
        },
        comercio: {
            prefix: "COCM",
            start: 1
        },
        outro: {
            prefix: "COO",
            start: 1
        }
    },
    "padre-cacique": {
        casa: {
            prefix: "PCD",
            start: 1
        },
        condominio: {
            prefix: "PCCD",
            start: 1
        },
        comercio: {
            prefix: "PCCM",
            start: 1
        },
        outro: {
            prefix: "PCO",
            start: 1
        }
    }
};
/* =========================
   STATE
========================= */ const $78b1059b43b96c0c$var$STATE = {
    currentStep: 1,
    totalSteps: 4,
    localType: "casa",
    registerType: "participante",
    generatedCode: "",
    consentAccepted: false,
    isSubmitting: false,
    geoRequestId: 0,
    geo: {
        lat: null,
        lng: null,
        addressLabel: ""
    }
};
/* =========================
   ELEMENTOS
========================= */ const $78b1059b43b96c0c$var$$ = (id)=>document.getElementById(id);
const $78b1059b43b96c0c$var$els = {
    form: $78b1059b43b96c0c$var$$("participantWizardForm"),
    formMessage: $78b1059b43b96c0c$var$$("formMessage"),
    stepIndicator: $78b1059b43b96c0c$var$$("stepIndicator"),
    progressText: $78b1059b43b96c0c$var$$("progressText"),
    progressBarFill: $78b1059b43b96c0c$var$$("progressBarFill"),
    territoryLabelView: $78b1059b43b96c0c$var$$("territoryLabelView"),
    userNameView: $78b1059b43b96c0c$var$$("userNameView"),
    consentLgpd: $78b1059b43b96c0c$var$$("consentLgpd"),
    consentWhatsapp: $78b1059b43b96c0c$var$$("consentWhatsapp"),
    consentImage: $78b1059b43b96c0c$var$$("consentImage"),
    btnAcceptAllConsents: $78b1059b43b96c0c$var$$("btnAcceptAllConsents"),
    consentAcceptedNote: $78b1059b43b96c0c$var$$("consentAcceptedNote"),
    fullName: $78b1059b43b96c0c$var$$("fullName"),
    phone: $78b1059b43b96c0c$var$$("phone"),
    email: $78b1059b43b96c0c$var$$("email"),
    cpf: $78b1059b43b96c0c$var$$("cpf"),
    localTypeGroup: $78b1059b43b96c0c$var$$("localTypeGroup"),
    registerTypeGroup: $78b1059b43b96c0c$var$$("registerTypeGroup"),
    generatedCode: $78b1059b43b96c0c$var$$("generatedCode"),
    cep: $78b1059b43b96c0c$var$$("cep"),
    btnBuscarCep: $78b1059b43b96c0c$var$$("btnBuscarCep"),
    number: $78b1059b43b96c0c$var$$("number"),
    street: $78b1059b43b96c0c$var$$("street"),
    neighborhood: $78b1059b43b96c0c$var$$("neighborhood"),
    city: $78b1059b43b96c0c$var$$("city"),
    state: $78b1059b43b96c0c$var$$("state"),
    referencePoint: $78b1059b43b96c0c$var$$("referencePoint"),
    geoPreview: $78b1059b43b96c0c$var$$("geoPreview"),
    latLngPreview: $78b1059b43b96c0c$var$$("latLngPreview"),
    difficultyGroup: $78b1059b43b96c0c$var$$("difficultyGroup"),
    householdMembers: $78b1059b43b96c0c$var$$("householdMembers"),
    projectSource: $78b1059b43b96c0c$var$$("projectSource"),
    projectSourceOther: $78b1059b43b96c0c$var$$("projectSourceOther"),
    successModal: $78b1059b43b96c0c$var$$("successModal"),
    closeSuccessModal: $78b1059b43b96c0c$var$$("closeSuccessModal"),
    newParticipantRegistration: $78b1059b43b96c0c$var$$("newParticipantRegistration"),
    menuToggle: $78b1059b43b96c0c$var$$("menuToggle"),
    mobileMenu: $78b1059b43b96c0c$var$$("mobileMenu"),
    btnSubmitParticipant: $78b1059b43b96c0c$var$$("btnSubmitParticipant")
};
/* =========================
   HELPERS
========================= */ function $78b1059b43b96c0c$var$onlyDigits(value = "") {
    return String(value).replace(/\D/g, "");
}
function $78b1059b43b96c0c$var$slugify(value = "") {
    return String(value).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim().replace(/\s+/g, "-");
}
function $78b1059b43b96c0c$var$normalizeName(name = "") {
    return String(name).normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().replace(/\s+/g, " ");
}
function $78b1059b43b96c0c$var$capitalizeWords(text = "") {
    return String(text).toLowerCase().replace(/\b\w/g, (m)=>m.toUpperCase());
}
function $78b1059b43b96c0c$var$showMessage(message, type = "info") {
    if (!$78b1059b43b96c0c$var$els.formMessage) return;
    $78b1059b43b96c0c$var$els.formMessage.classList.remove("hidden", "error", "success", "info", "warning");
    $78b1059b43b96c0c$var$els.formMessage.classList.add(type);
    $78b1059b43b96c0c$var$els.formMessage.textContent = message;
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
function $78b1059b43b96c0c$var$clearMessage() {
    if (!$78b1059b43b96c0c$var$els.formMessage) return;
    $78b1059b43b96c0c$var$els.formMessage.classList.add("hidden");
    $78b1059b43b96c0c$var$els.formMessage.textContent = "";
    $78b1059b43b96c0c$var$els.formMessage.classList.remove("error", "success", "info", "warning");
}
function $78b1059b43b96c0c$var$setLoading(button, isLoading, loadingText = "Salvando...") {
    if (!button) return;
    if (isLoading) {
        if (!button.dataset.originalText) button.dataset.originalText = button.textContent;
        button.disabled = true;
        button.textContent = loadingText;
    } else {
        button.disabled = false;
        button.textContent = button.dataset.originalText || "Salvar";
    }
}
function $78b1059b43b96c0c$var$formatPhone(value = "") {
    const digits = $78b1059b43b96c0c$var$onlyDigits(value).slice(0, 11);
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}
function $78b1059b43b96c0c$var$formatCPF(value = "") {
    const digits = $78b1059b43b96c0c$var$onlyDigits(value).slice(0, 11);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
    if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
    return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}
function $78b1059b43b96c0c$var$formatCEP(value = "") {
    const digits = $78b1059b43b96c0c$var$onlyDigits(value).slice(0, 8);
    if (digits.length <= 5) return digits;
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}
function $78b1059b43b96c0c$var$isValidEmail(email = "") {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
}
function $78b1059b43b96c0c$var$isValidCPF(cpf = "") {
    const digits = $78b1059b43b96c0c$var$onlyDigits(cpf);
    if (!digits) return true;
    if (digits.length !== 11) return false;
    if (/^(\d)\1+$/.test(digits)) return false;
    let sum = 0;
    for(let i = 0; i < 9; i++)sum += Number(digits[i]) * (10 - i);
    let firstDigit = sum * 10 % 11;
    if (firstDigit === 10) firstDigit = 0;
    if (firstDigit !== Number(digits[9])) return false;
    sum = 0;
    for(let i = 0; i < 10; i++)sum += Number(digits[i]) * (11 - i);
    let secondDigit = sum * 10 % 11;
    if (secondDigit === 10) secondDigit = 0;
    if (secondDigit !== Number(digits[10])) return false;
    return true;
}
/* =========================
   CONFIG AUXILIAR
========================= */ function $78b1059b43b96c0c$var$getCanonicalTerritoryId() {
    return $78b1059b43b96c0c$var$CONFIG.territoryId;
}
function $78b1059b43b96c0c$var$getCanonicalTerritoryLabel() {
    return $78b1059b43b96c0c$var$CONFIG.territoryLabel;
}
function $78b1059b43b96c0c$var$getCodeTerritoryKey() {
    return String($78b1059b43b96c0c$var$CONFIG.territorySlug || $78b1059b43b96c0c$var$CONFIG.territoryId || "").toLowerCase().replace(/^crgr_/, "").replace(/_/g, "-").trim();
}
function $78b1059b43b96c0c$var$getCodeLocalType() {
    const localType = String($78b1059b43b96c0c$var$STATE.localType || "casa").trim();
    if (localType === "condominio") return "condominio";
    if (localType === "comercio") return "comercio";
    if (localType === "outro") return "outro";
    return "casa";
}
function $78b1059b43b96c0c$var$assertRuntimeConfig() {
    if (!$78b1059b43b96c0c$var$CONFIG.territoryId || !$78b1059b43b96c0c$var$CONFIG.territoryLabel) throw new Error("Configura\xe7\xe3o do territ\xf3rio ausente. Verifique os atributos data-territory-id e data-territory-label no body.");
}
/* =========================
   CÓDIGO SEQUENCIAL
========================= */ async function $78b1059b43b96c0c$var$generateSequentialCode() {
    const territoryKey = $78b1059b43b96c0c$var$getCodeTerritoryKey();
    const localTypeKey = $78b1059b43b96c0c$var$getCodeLocalType();
    const config = $78b1059b43b96c0c$var$CODE_CONFIG[territoryKey]?.[localTypeKey];
    if (!config) throw new Error(`Configura\xe7\xe3o de c\xf3digo n\xe3o encontrada para ${territoryKey}/${localTypeKey}.`);
    const { prefix: prefix, start: start } = config;
    const q = (0, $ilpIi.query)((0, $ilpIi.collection)((0, $dbOS5.db), "participants"), (0, $ilpIi.where)("territoryId", "==", $78b1059b43b96c0c$var$getCanonicalTerritoryId()), (0, $ilpIi.where)("codeLocalType", "==", localTypeKey));
    const snapshot = await (0, $ilpIi.getDocs)(q);
    let maxNumber = 0;
    snapshot.forEach((docSnap)=>{
        const data = docSnap.data() || {};
        const code = String(data.participantCode || "").trim();
        if (!code.startsWith(`${prefix}-`)) return;
        const numberPart = Number(code.split("-")[1]);
        if (Number.isFinite(numberPart) && numberPart > maxNumber) maxNumber = numberPart;
    });
    const nextNumber = Math.max(start, maxNumber + 1);
    return `${prefix}-${String(nextNumber).padStart(4, "0")}`;
}
function $78b1059b43b96c0c$var$getRegisterTypeByLocalType(localType) {
    return localType === "condominio" ? "condominio" : "participante";
}
/* =========================
   GEO PREVIEW
========================= */ function $78b1059b43b96c0c$var$updateGeoPreview() {
    if ($78b1059b43b96c0c$var$els.geoPreview) $78b1059b43b96c0c$var$els.geoPreview.textContent = $78b1059b43b96c0c$var$STATE.geo.addressLabel || "ainda n\xe3o calculado";
    if ($78b1059b43b96c0c$var$els.latLngPreview) {
        if ($78b1059b43b96c0c$var$STATE.geo.lat != null && $78b1059b43b96c0c$var$STATE.geo.lng != null) $78b1059b43b96c0c$var$els.latLngPreview.textContent = `${$78b1059b43b96c0c$var$STATE.geo.lat}, ${$78b1059b43b96c0c$var$STATE.geo.lng}`;
        else $78b1059b43b96c0c$var$els.latLngPreview.textContent = "ainda n\xe3o calculado";
    }
}
function $78b1059b43b96c0c$var$resetGeo() {
    $78b1059b43b96c0c$var$STATE.geo = {
        lat: null,
        lng: null,
        addressLabel: ""
    };
    $78b1059b43b96c0c$var$updateGeoPreview();
}
/* =========================
   TIPO DE LOCAL / CÓDIGO
========================= */ function $78b1059b43b96c0c$var$syncRegisterTypeUI() {
    const buttons = $78b1059b43b96c0c$var$els.registerTypeGroup?.querySelectorAll("[data-register-type]") || [];
    buttons.forEach((btn)=>{
        const registerType = btn.dataset.registerType;
        const isSelected = registerType === $78b1059b43b96c0c$var$STATE.registerType;
        const shouldBeDisabled = $78b1059b43b96c0c$var$STATE.localType === "condominio" ? registerType !== "condominio" : registerType === "condominio";
        btn.classList.toggle("selected", isSelected);
        btn.classList.toggle("is-disabled", shouldBeDisabled);
        btn.setAttribute("aria-pressed", isSelected ? "true" : "false");
    });
}
async function $78b1059b43b96c0c$var$setRegisterType(registerType, regenerate = true) {
    $78b1059b43b96c0c$var$STATE.registerType = registerType;
    if (regenerate || !$78b1059b43b96c0c$var$STATE.generatedCode) $78b1059b43b96c0c$var$STATE.generatedCode = await $78b1059b43b96c0c$var$generateSequentialCode();
    if ($78b1059b43b96c0c$var$els.generatedCode) $78b1059b43b96c0c$var$els.generatedCode.value = $78b1059b43b96c0c$var$STATE.generatedCode;
    $78b1059b43b96c0c$var$syncRegisterTypeUI();
}
async function $78b1059b43b96c0c$var$setLocalType(localType) {
    $78b1059b43b96c0c$var$STATE.localType = localType;
    const buttons = $78b1059b43b96c0c$var$els.localTypeGroup?.querySelectorAll("[data-local-type]") || [];
    buttons.forEach((btn)=>{
        const selected = btn.dataset.localType === localType;
        btn.classList.toggle("selected", selected);
        btn.setAttribute("aria-pressed", selected ? "true" : "false");
    });
    const autoRegisterType = $78b1059b43b96c0c$var$getRegisterTypeByLocalType(localType);
    try {
        await $78b1059b43b96c0c$var$setRegisterType(autoRegisterType, true);
    } catch (error) {
        console.warn("N\xe3o foi poss\xedvel gerar o c\xf3digo neste momento:", error);
        if ($78b1059b43b96c0c$var$els.generatedCode) $78b1059b43b96c0c$var$els.generatedCode.value = "Ser\xe1 gerado ao concluir";
    }
}
/* =========================
   STEPS
========================= */ function $78b1059b43b96c0c$var$getStepCards() {
    return Array.from(document.querySelectorAll(".step-card"));
}
function $78b1059b43b96c0c$var$updateProgress() {
    if ($78b1059b43b96c0c$var$els.stepIndicator) $78b1059b43b96c0c$var$els.stepIndicator.textContent = `Etapa ${$78b1059b43b96c0c$var$STATE.currentStep} de ${$78b1059b43b96c0c$var$STATE.totalSteps}`;
    if ($78b1059b43b96c0c$var$els.progressText) $78b1059b43b96c0c$var$els.progressText.textContent = `Progresso: ${$78b1059b43b96c0c$var$STATE.currentStep}/${$78b1059b43b96c0c$var$STATE.totalSteps}`;
    if ($78b1059b43b96c0c$var$els.progressBarFill) {
        const pct = $78b1059b43b96c0c$var$STATE.currentStep / $78b1059b43b96c0c$var$STATE.totalSteps * 100;
        $78b1059b43b96c0c$var$els.progressBarFill.style.width = `${pct}%`;
    }
    $78b1059b43b96c0c$var$getStepCards().forEach((card)=>{
        const step = Number(card.dataset.step);
        const isActive = step === $78b1059b43b96c0c$var$STATE.currentStep;
        card.classList.toggle("is-active", isActive);
        card.classList.toggle("hidden", !isActive);
    });
}
function $78b1059b43b96c0c$var$goToStep(step) {
    if (step < 1 || step > $78b1059b43b96c0c$var$STATE.totalSteps) return;
    $78b1059b43b96c0c$var$STATE.currentStep = step;
    $78b1059b43b96c0c$var$updateProgress();
    $78b1059b43b96c0c$var$clearMessage();
    window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
}
/* =========================
   VALIDAÇÃO
========================= */ function $78b1059b43b96c0c$var$validateStep1() {
    if (!$78b1059b43b96c0c$var$STATE.consentAccepted) {
        $78b1059b43b96c0c$var$showMessage("Para continuar, clique em \u201CConcordo com todas as autoriza\xe7\xf5es\u201D.", "error");
        $78b1059b43b96c0c$var$els.btnAcceptAllConsents?.focus();
        return false;
    }
    return true;
}
function $78b1059b43b96c0c$var$validateStep2() {
    const fullName = $78b1059b43b96c0c$var$normalizeName($78b1059b43b96c0c$var$els.fullName?.value);
    const phone = $78b1059b43b96c0c$var$onlyDigits($78b1059b43b96c0c$var$els.phone?.value);
    const email = String($78b1059b43b96c0c$var$els.email?.value || "").trim();
    const cpf = String($78b1059b43b96c0c$var$els.cpf?.value || "").trim();
    if (!fullName || fullName.length < 5) {
        $78b1059b43b96c0c$var$showMessage("Informe o nome completo corretamente.", "error");
        $78b1059b43b96c0c$var$els.fullName?.focus();
        return false;
    }
    if (phone.length < 10 || phone.length > 11) {
        $78b1059b43b96c0c$var$showMessage("Informe um telefone/WhatsApp v\xe1lido com DDD.", "error");
        $78b1059b43b96c0c$var$els.phone?.focus();
        return false;
    }
    if (email && !$78b1059b43b96c0c$var$isValidEmail(email)) {
        $78b1059b43b96c0c$var$showMessage("O e-mail informado n\xe3o \xe9 v\xe1lido. Corrija ou deixe o campo em branco.", "error");
        $78b1059b43b96c0c$var$els.email?.focus();
        return false;
    }
    if (cpf && !$78b1059b43b96c0c$var$isValidCPF(cpf)) {
        $78b1059b43b96c0c$var$showMessage("O CPF informado n\xe3o \xe9 v\xe1lido. Corrija ou deixe o campo em branco.", "error");
        $78b1059b43b96c0c$var$els.cpf?.focus();
        return false;
    }
    return true;
}
function $78b1059b43b96c0c$var$validateStep3() {
    const referencePoint = String($78b1059b43b96c0c$var$els.referencePoint?.value || "").trim();
    if (!referencePoint) {
        $78b1059b43b96c0c$var$showMessage("Informe o ponto de refer\xeancia.", "error");
        $78b1059b43b96c0c$var$els.referencePoint?.focus();
        return false;
    }
    return true;
}
function $78b1059b43b96c0c$var$validateStep4() {
    return true;
}
function $78b1059b43b96c0c$var$validateCurrentStep() {
    switch($78b1059b43b96c0c$var$STATE.currentStep){
        case 1:
            return $78b1059b43b96c0c$var$validateStep1();
        case 2:
            return $78b1059b43b96c0c$var$validateStep2();
        case 3:
            return $78b1059b43b96c0c$var$validateStep3();
        case 4:
            return $78b1059b43b96c0c$var$validateStep4();
        default:
            return true;
    }
}
/* =========================
   CEP + GEO
========================= */ async function $78b1059b43b96c0c$var$fetchCEP(cep) {
    const cleanCep = $78b1059b43b96c0c$var$onlyDigits(cep);
    if (cleanCep.length !== 8) throw new Error("CEP inv\xe1lido.");
    const url = `${$78b1059b43b96c0c$var$CONFIG.viacepBase}/${cleanCep}/json/`;
    const response = await fetch(url);
    if (!response.ok) throw new Error("Falha ao consultar o CEP.");
    const data = await response.json();
    if (data.erro) throw new Error("CEP n\xe3o encontrado.");
    return data;
}
async function $78b1059b43b96c0c$var$geocodeAddress() {
    const street = String($78b1059b43b96c0c$var$els.street?.value || "").trim();
    const number = String($78b1059b43b96c0c$var$els.number?.value || "").trim();
    const neighborhood = String($78b1059b43b96c0c$var$els.neighborhood?.value || "").trim();
    const city = String($78b1059b43b96c0c$var$els.city?.value || "").trim();
    const state = String($78b1059b43b96c0c$var$els.state?.value || "").trim();
    const cep = $78b1059b43b96c0c$var$onlyDigits($78b1059b43b96c0c$var$els.cep?.value);
    if (!street || !number || !city || !state) return null;
    const queryText = `${street}, ${number}, ${neighborhood}, ${city}, ${state}, Brasil, ${cep}`;
    const url = new URL($78b1059b43b96c0c$var$CONFIG.nominatimBase);
    url.searchParams.set("format", "jsonv2");
    url.searchParams.set("limit", "1");
    url.searchParams.set("countrycodes", "br");
    url.searchParams.set("q", queryText);
    const response = await fetch(url.toString(), {
        headers: {
            Accept: "application/json"
        }
    });
    if (!response.ok) throw new Error("Falha ao geocodificar endere\xe7o.");
    const results = await response.json();
    if (!Array.isArray(results) || !results.length) return null;
    const result = results[0];
    return {
        lat: Number(result.lat),
        lng: Number(result.lon),
        addressLabel: result.display_name || queryText
    };
}
async function $78b1059b43b96c0c$var$handleBuscarCep() {
    $78b1059b43b96c0c$var$clearMessage();
    try {
        const data = await $78b1059b43b96c0c$var$fetchCEP($78b1059b43b96c0c$var$els.cep?.value || "");
        if ($78b1059b43b96c0c$var$els.street) $78b1059b43b96c0c$var$els.street.value = data.logradouro || "";
        if ($78b1059b43b96c0c$var$els.neighborhood) $78b1059b43b96c0c$var$els.neighborhood.value = data.bairro || "";
        if ($78b1059b43b96c0c$var$els.city) $78b1059b43b96c0c$var$els.city.value = data.localidade || "";
        if ($78b1059b43b96c0c$var$els.state) $78b1059b43b96c0c$var$els.state.value = data.uf || "";
        $78b1059b43b96c0c$var$showMessage("CEP encontrado com sucesso.", "success");
        await $78b1059b43b96c0c$var$tryGeocodeWhenReady(true);
    } catch (error) {
        $78b1059b43b96c0c$var$resetGeo();
        $78b1059b43b96c0c$var$showMessage(error.message || "N\xe3o foi poss\xedvel buscar o CEP.", "error");
    }
}
async function $78b1059b43b96c0c$var$tryGeocodeWhenReady(force = false) {
    const requiredReady = String($78b1059b43b96c0c$var$els.street?.value || "").trim() && String($78b1059b43b96c0c$var$els.number?.value || "").trim() && String($78b1059b43b96c0c$var$els.city?.value || "").trim() && String($78b1059b43b96c0c$var$els.state?.value || "").trim();
    if (!requiredReady) {
        if (force) $78b1059b43b96c0c$var$resetGeo();
        return;
    }
    const requestId = ++$78b1059b43b96c0c$var$STATE.geoRequestId;
    try {
        const geo = await $78b1059b43b96c0c$var$geocodeAddress();
        if (requestId !== $78b1059b43b96c0c$var$STATE.geoRequestId) return;
        $78b1059b43b96c0c$var$STATE.geo = geo || {
            lat: null,
            lng: null,
            addressLabel: ""
        };
        $78b1059b43b96c0c$var$updateGeoPreview();
    } catch  {
        if (requestId !== $78b1059b43b96c0c$var$STATE.geoRequestId) return;
        $78b1059b43b96c0c$var$resetGeo();
    }
}
/* =========================
   PAYLOAD
========================= */ function $78b1059b43b96c0c$var$getSelectedDifficulty() {
    return $78b1059b43b96c0c$var$els.difficultyGroup?.querySelector(".choice-card.selected")?.dataset?.difficulty || "sim";
}
function $78b1059b43b96c0c$var$getProjectSourceLabel() {
    if (!$78b1059b43b96c0c$var$els.projectSource) return null;
    const selectedOption = $78b1059b43b96c0c$var$els.projectSource.options[$78b1059b43b96c0c$var$els.projectSource.selectedIndex];
    return selectedOption?.textContent?.trim() || null;
}
function $78b1059b43b96c0c$var$buildAddressLabel() {
    const cepDigits = $78b1059b43b96c0c$var$onlyDigits($78b1059b43b96c0c$var$els.cep?.value || "");
    const street = String($78b1059b43b96c0c$var$els.street?.value || "").trim();
    const number = String($78b1059b43b96c0c$var$els.number?.value || "").trim();
    const neighborhood = String($78b1059b43b96c0c$var$els.neighborhood?.value || "").trim();
    const city = String($78b1059b43b96c0c$var$els.city?.value || "").trim();
    const state = String($78b1059b43b96c0c$var$els.state?.value || "").trim().toUpperCase();
    const referencePoint = String($78b1059b43b96c0c$var$els.referencePoint?.value || "").trim();
    const enderecoCompleto = [
        street && number ? `${street}, ${number}` : street || number,
        neighborhood,
        city || state ? `${city}${city && state ? ", " : ""}${state}` : "",
        cepDigits ? `CEP ${$78b1059b43b96c0c$var$formatCEP(cepDigits)}` : "",
        "Brasil"
    ].filter(Boolean).join(" - ");
    return enderecoCompleto || referencePoint;
}
function $78b1059b43b96c0c$var$buildParticipantPayload() {
    const territoryId = $78b1059b43b96c0c$var$getCanonicalTerritoryId();
    const territoryLabel = $78b1059b43b96c0c$var$getCanonicalTerritoryLabel();
    const fullName = $78b1059b43b96c0c$var$capitalizeWords($78b1059b43b96c0c$var$normalizeName($78b1059b43b96c0c$var$els.fullName?.value || ""));
    const phoneDigits = $78b1059b43b96c0c$var$onlyDigits($78b1059b43b96c0c$var$els.phone?.value || "");
    const email = String($78b1059b43b96c0c$var$els.email?.value || "").trim().toLowerCase();
    const cpfDigits = $78b1059b43b96c0c$var$onlyDigits($78b1059b43b96c0c$var$els.cpf?.value || "");
    const cepDigits = $78b1059b43b96c0c$var$onlyDigits($78b1059b43b96c0c$var$els.cep?.value || "");
    const street = String($78b1059b43b96c0c$var$els.street?.value || "").trim();
    const number = String($78b1059b43b96c0c$var$els.number?.value || "").trim();
    const neighborhood = String($78b1059b43b96c0c$var$els.neighborhood?.value || "").trim();
    const city = String($78b1059b43b96c0c$var$els.city?.value || "").trim();
    const state = String($78b1059b43b96c0c$var$els.state?.value || "").trim().toUpperCase();
    const referencePoint = String($78b1059b43b96c0c$var$els.referencePoint?.value || "").trim();
    const difficulty = $78b1059b43b96c0c$var$getSelectedDifficulty();
    const householdMembers = String($78b1059b43b96c0c$var$els.householdMembers?.value || "").trim();
    const projectSource = String($78b1059b43b96c0c$var$els.projectSource?.value || "").trim() || null;
    const projectSourceLabel = $78b1059b43b96c0c$var$getProjectSourceLabel();
    const projectSourceOther = String($78b1059b43b96c0c$var$els.projectSourceOther?.value || "").trim() || null;
    return {
        name: fullName,
        fullName: fullName,
        nameLower: $78b1059b43b96c0c$var$slugify(fullName),
        phone: phoneDigits,
        email: email || null,
        cpf: cpfDigits || null,
        localType: $78b1059b43b96c0c$var$STATE.localType,
        codeLocalType: $78b1059b43b96c0c$var$getCodeLocalType(),
        registerType: $78b1059b43b96c0c$var$STATE.registerType,
        participantType: $78b1059b43b96c0c$var$STATE.registerType,
        participantCode: $78b1059b43b96c0c$var$STATE.generatedCode,
        cep: cepDigits || null,
        rua: street || null,
        street: street || null,
        numero: number || null,
        neighborhood: neighborhood || null,
        bairro: neighborhood || null,
        city: city || null,
        cidade: city || null,
        uf: state || null,
        state: state || null,
        referencePoint: referencePoint,
        enderecoCompleto: $78b1059b43b96c0c$var$buildAddressLabel(),
        address: $78b1059b43b96c0c$var$buildAddressLabel(),
        territoryId: territoryId,
        territoryLabel: territoryLabel,
        lat: $78b1059b43b96c0c$var$STATE.geo.lat ?? null,
        lng: $78b1059b43b96c0c$var$STATE.geo.lng ?? null,
        geoAddressLabel: $78b1059b43b96c0c$var$STATE.geo.addressLabel || "",
        consentLgpd: true,
        consentWhatsapp: true,
        consentImage: true,
        consentAccepted: true,
        difficulty: difficulty,
        householdMembers: householdMembers,
        projectSource: projectSource,
        projectSourceLabel: projectSourceLabel,
        projectSourceOther: projectSourceOther,
        status: "pending_approval",
        approvalStatus: "pending",
        origin: "public_form",
        source: "cadastro-publico",
        inTerritory: true,
        inOperation: false,
        active: false,
        createdAt: (0, $ilpIi.serverTimestamp)(),
        createdAtISO: new Date().toISOString()
    };
}
function $78b1059b43b96c0c$var$buildApprovalRequestPayload(participantId, participantData) {
    const territoryId = $78b1059b43b96c0c$var$getCanonicalTerritoryId();
    const territoryLabel = $78b1059b43b96c0c$var$getCanonicalTerritoryLabel();
    return {
        type: "participant_registration",
        targetCollection: "participants",
        targetId: participantId,
        territoryId: territoryId,
        territoryLabel: territoryLabel,
        participantCode: participantData.participantCode,
        participantName: participantData.name,
        participantEmail: participantData.email || null,
        participantPhone: participantData.phone,
        participantCpf: participantData.cpf || null,
        registerType: participantData.registerType,
        localType: participantData.localType,
        codeLocalType: participantData.codeLocalType,
        status: "pending",
        decision: null,
        reviewedAt: null,
        reviewedBy: null,
        reviewedByName: null,
        reviewNote: null,
        source: "cadastro-publico",
        summary: `Novo cadastro enviado por ${participantData.name} para aprova\xe7\xe3o da cooperativa.`,
        payloadSnapshot: {
            name: participantData.name,
            email: participantData.email || null,
            phone: participantData.phone,
            cpf: participantData.cpf || null,
            participantCode: participantData.participantCode,
            registerType: participantData.registerType,
            localType: participantData.localType,
            codeLocalType: participantData.codeLocalType,
            territoryId: territoryId,
            territoryLabel: territoryLabel,
            enderecoCompleto: participantData.enderecoCompleto,
            referencePoint: participantData.referencePoint,
            lat: participantData.lat ?? null,
            lng: participantData.lng ?? null,
            householdMembers: participantData.householdMembers,
            projectSource: participantData.projectSource,
            projectSourceLabel: participantData.projectSourceLabel,
            projectSourceOther: participantData.projectSourceOther
        },
        createdAt: (0, $ilpIi.serverTimestamp)(),
        createdAtISO: new Date().toISOString()
    };
}
async function $78b1059b43b96c0c$var$saveRegistration() {
    if (!$78b1059b43b96c0c$var$STATE.generatedCode || $78b1059b43b96c0c$var$STATE.generatedCode === "Ser\xe1 gerado ao concluir") {
        $78b1059b43b96c0c$var$STATE.generatedCode = await $78b1059b43b96c0c$var$generateSequentialCode();
        if ($78b1059b43b96c0c$var$els.generatedCode) $78b1059b43b96c0c$var$els.generatedCode.value = $78b1059b43b96c0c$var$STATE.generatedCode;
    }
    const participantPayload = $78b1059b43b96c0c$var$buildParticipantPayload();
    const participantRef = await (0, $ilpIi.addDoc)((0, $ilpIi.collection)((0, $dbOS5.db), "participants"), participantPayload);
    const approvalRequestPayload = $78b1059b43b96c0c$var$buildApprovalRequestPayload(participantRef.id, participantPayload);
    const approvalRef = await (0, $ilpIi.addDoc)((0, $ilpIi.collection)((0, $dbOS5.db), "approvalRequests"), approvalRequestPayload);
    return {
        participantId: participantRef.id,
        approvalRequestId: approvalRef.id,
        participantCode: participantPayload.participantCode
    };
}
/* =========================
   MODAL
========================= */ function $78b1059b43b96c0c$var$openSuccessModal() {
    if (!$78b1059b43b96c0c$var$els.successModal) return;
    $78b1059b43b96c0c$var$els.successModal.classList.remove("hidden");
    $78b1059b43b96c0c$var$els.successModal.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
}
function $78b1059b43b96c0c$var$closeSuccessModal() {
    if (!$78b1059b43b96c0c$var$els.successModal) return;
    $78b1059b43b96c0c$var$els.successModal.classList.add("hidden");
    $78b1059b43b96c0c$var$els.successModal.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    window.location.href = $78b1059b43b96c0c$var$CONFIG.redirectAfterSuccess;
}
/* =========================
   EVENTS
========================= */ function $78b1059b43b96c0c$var$bindConsentButton() {
    const btn = document.getElementById("btnAcceptAllConsents");
    const note = document.getElementById("consentAcceptedNote");
    btn?.addEventListener("click", ()=>{
        $78b1059b43b96c0c$var$STATE.consentAccepted = true;
        if ($78b1059b43b96c0c$var$els.consentLgpd) $78b1059b43b96c0c$var$els.consentLgpd.checked = true;
        if ($78b1059b43b96c0c$var$els.consentWhatsapp) $78b1059b43b96c0c$var$els.consentWhatsapp.checked = true;
        if ($78b1059b43b96c0c$var$els.consentImage) $78b1059b43b96c0c$var$els.consentImage.checked = true;
        btn.classList.add("is-accepted");
        btn.innerHTML = "\u2705 Autoriza\xe7\xf5es confirmadas";
        btn.disabled = true;
        if (note) {
            note.classList.remove("hidden");
            note.style.display = "flex";
        }
        $78b1059b43b96c0c$var$clearMessage();
    });
}
function $78b1059b43b96c0c$var$bindProjectSourceSelect() {
    $78b1059b43b96c0c$var$els.projectSource?.addEventListener("change", ()=>{
        if (!$78b1059b43b96c0c$var$els.projectSourceOther) return;
        if ($78b1059b43b96c0c$var$els.projectSource.value === "outro") {
            $78b1059b43b96c0c$var$els.projectSourceOther.classList.remove("hidden");
            $78b1059b43b96c0c$var$els.projectSourceOther.focus();
        } else {
            $78b1059b43b96c0c$var$els.projectSourceOther.classList.add("hidden");
            $78b1059b43b96c0c$var$els.projectSourceOther.value = "";
        }
    });
}
function $78b1059b43b96c0c$var$bindStepNavigation() {
    document.querySelectorAll("[data-next-step]").forEach((button)=>{
        button.addEventListener("click", async ()=>{
            $78b1059b43b96c0c$var$clearMessage();
            if (!$78b1059b43b96c0c$var$validateCurrentStep()) return;
            if ($78b1059b43b96c0c$var$STATE.currentStep === 3) await $78b1059b43b96c0c$var$tryGeocodeWhenReady(true);
            $78b1059b43b96c0c$var$goToStep($78b1059b43b96c0c$var$STATE.currentStep + 1);
        });
    });
    document.querySelectorAll("[data-prev-step]").forEach((button)=>{
        button.addEventListener("click", ()=>{
            $78b1059b43b96c0c$var$clearMessage();
            $78b1059b43b96c0c$var$goToStep($78b1059b43b96c0c$var$STATE.currentStep - 1);
        });
    });
}
function $78b1059b43b96c0c$var$bindLocalTypeButtons() {
    const buttons = $78b1059b43b96c0c$var$els.localTypeGroup?.querySelectorAll("[data-local-type]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", async ()=>{
            await $78b1059b43b96c0c$var$setLocalType(button.dataset.localType);
            $78b1059b43b96c0c$var$clearMessage();
        });
    });
}
function $78b1059b43b96c0c$var$bindRegisterTypeButtons() {
    const buttons = $78b1059b43b96c0c$var$els.registerTypeGroup?.querySelectorAll("[data-register-type]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", async ()=>{
            if (button.classList.contains("is-disabled")) return;
            await $78b1059b43b96c0c$var$setRegisterType(button.dataset.registerType, true);
            $78b1059b43b96c0c$var$clearMessage();
        });
    });
}
function $78b1059b43b96c0c$var$bindDifficultyButtons() {
    const buttons = $78b1059b43b96c0c$var$els.difficultyGroup?.querySelectorAll("[data-difficulty]") || [];
    buttons.forEach((button)=>{
        button.addEventListener("click", ()=>{
            buttons.forEach((btn)=>btn.classList.remove("selected"));
            button.classList.add("selected");
        });
    });
}
function $78b1059b43b96c0c$var$bindFormatters() {
    $78b1059b43b96c0c$var$els.phone?.addEventListener("input", (event)=>{
        event.target.value = $78b1059b43b96c0c$var$formatPhone(event.target.value);
    });
    $78b1059b43b96c0c$var$els.cpf?.addEventListener("input", (event)=>{
        event.target.value = $78b1059b43b96c0c$var$formatCPF(event.target.value);
    });
    $78b1059b43b96c0c$var$els.cep?.addEventListener("input", (event)=>{
        event.target.value = $78b1059b43b96c0c$var$formatCEP(event.target.value);
    });
}
function $78b1059b43b96c0c$var$bindGeoEvents() {
    $78b1059b43b96c0c$var$els.btnBuscarCep?.addEventListener("click", $78b1059b43b96c0c$var$handleBuscarCep);
    [
        "number",
        "street",
        "neighborhood",
        "city",
        "state",
        "cep"
    ].forEach((id)=>{
        const el = $78b1059b43b96c0c$var$$(id);
        if (!el) return;
        el.addEventListener("change", async ()=>{
            await $78b1059b43b96c0c$var$tryGeocodeWhenReady(false);
        });
        el.addEventListener("blur", async ()=>{
            await $78b1059b43b96c0c$var$tryGeocodeWhenReady(false);
        });
    });
}
function $78b1059b43b96c0c$var$bindMenu() {
    $78b1059b43b96c0c$var$els.menuToggle?.addEventListener("click", ()=>{
        $78b1059b43b96c0c$var$els.mobileMenu?.classList.toggle("show");
        $78b1059b43b96c0c$var$els.mobileMenu?.classList.toggle("open");
    });
}
function $78b1059b43b96c0c$var$bindSuccessModal() {
    $78b1059b43b96c0c$var$els.closeSuccessModal?.addEventListener("click", $78b1059b43b96c0c$var$closeSuccessModal);
    $78b1059b43b96c0c$var$els.newParticipantRegistration?.addEventListener("click", ()=>{
        window.location.reload();
    });
    $78b1059b43b96c0c$var$els.successModal?.querySelector(".success-modal-backdrop")?.addEventListener("click", $78b1059b43b96c0c$var$closeSuccessModal);
}
function $78b1059b43b96c0c$var$bindSubmit() {
    $78b1059b43b96c0c$var$els.form?.addEventListener("submit", async (event)=>{
        event.preventDefault();
        $78b1059b43b96c0c$var$clearMessage();
        if ($78b1059b43b96c0c$var$STATE.isSubmitting) return;
        if (!$78b1059b43b96c0c$var$validateStep1()) return;
        if (!$78b1059b43b96c0c$var$validateStep2()) return;
        if (!$78b1059b43b96c0c$var$validateStep3()) return;
        if (!$78b1059b43b96c0c$var$validateStep4()) return;
        $78b1059b43b96c0c$var$STATE.isSubmitting = true;
        $78b1059b43b96c0c$var$setLoading($78b1059b43b96c0c$var$els.btnSubmitParticipant, true, "Enviando cadastro...");
        try {
            await $78b1059b43b96c0c$var$tryGeocodeWhenReady(true);
            const result = await $78b1059b43b96c0c$var$saveRegistration();
            $78b1059b43b96c0c$var$showMessage(`Cadastro enviado com sucesso para an\xe1lise da cooperativa. C\xf3digo gerado: ${result.participantCode}`, "success");
            $78b1059b43b96c0c$var$openSuccessModal();
        } catch (error) {
            console.error("Erro ao salvar cadastro:", error);
            $78b1059b43b96c0c$var$showMessage(error?.message || "N\xe3o foi poss\xedvel enviar o cadastro. Verifique as regras do Firestore para participants e approvalRequests.", "error");
        } finally{
            $78b1059b43b96c0c$var$STATE.isSubmitting = false;
            $78b1059b43b96c0c$var$setLoading($78b1059b43b96c0c$var$els.btnSubmitParticipant, false);
        }
    });
}
/* =========================
   INIT
========================= */ function $78b1059b43b96c0c$var$initStaticTexts() {
    if ($78b1059b43b96c0c$var$els.territoryLabelView) $78b1059b43b96c0c$var$els.territoryLabelView.textContent = $78b1059b43b96c0c$var$getCanonicalTerritoryLabel();
    if ($78b1059b43b96c0c$var$els.userNameView) $78b1059b43b96c0c$var$els.userNameView.textContent = "Cadastro p\xfablico";
}
async function $78b1059b43b96c0c$var$initDefaults() {
    $78b1059b43b96c0c$var$STATE.consentAccepted = false;
    if ($78b1059b43b96c0c$var$els.consentLgpd) $78b1059b43b96c0c$var$els.consentLgpd.checked = true;
    if ($78b1059b43b96c0c$var$els.consentWhatsapp) $78b1059b43b96c0c$var$els.consentWhatsapp.checked = true;
    if ($78b1059b43b96c0c$var$els.consentImage) $78b1059b43b96c0c$var$els.consentImage.checked = true;
    if ($78b1059b43b96c0c$var$els.projectSourceOther) $78b1059b43b96c0c$var$els.projectSourceOther.classList.add("hidden");
    $78b1059b43b96c0c$var$updateGeoPreview();
    $78b1059b43b96c0c$var$updateProgress();
    try {
        await $78b1059b43b96c0c$var$setLocalType("casa");
    } catch (error) {
        console.warn("N\xe3o foi poss\xedvel gerar o c\xf3digo inicial:", error);
        if ($78b1059b43b96c0c$var$els.generatedCode) $78b1059b43b96c0c$var$els.generatedCode.value = "Ser\xe1 gerado ao concluir";
    }
}
async function $78b1059b43b96c0c$var$init() {
    try {
        $78b1059b43b96c0c$var$assertRuntimeConfig();
        $78b1059b43b96c0c$var$initStaticTexts();
        $78b1059b43b96c0c$var$bindConsentButton();
        $78b1059b43b96c0c$var$bindStepNavigation();
        $78b1059b43b96c0c$var$bindLocalTypeButtons();
        $78b1059b43b96c0c$var$bindRegisterTypeButtons();
        $78b1059b43b96c0c$var$bindDifficultyButtons();
        $78b1059b43b96c0c$var$bindProjectSourceSelect();
        $78b1059b43b96c0c$var$bindFormatters();
        $78b1059b43b96c0c$var$bindGeoEvents();
        $78b1059b43b96c0c$var$bindMenu();
        $78b1059b43b96c0c$var$bindSuccessModal();
        $78b1059b43b96c0c$var$bindSubmit();
        await $78b1059b43b96c0c$var$initDefaults();
    } catch (error) {
        console.error("Erro ao iniciar formul\xe1rio:", error);
        $78b1059b43b96c0c$var$showMessage(error?.message || "N\xe3o foi poss\xedvel iniciar o formul\xe1rio.", "error");
    }
}
$78b1059b43b96c0c$var$init();


//# sourceMappingURL=cadastro-participantes-cooadesc.bc56cfac.js.map
